
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import { MdCheck } from "react-icons/md";
const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: 10px;
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: 5px;
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-color: ${({showErrors}) => showErrors && "var(--color-red)"};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 20px;

            .checkbox{
                width: 22px;
                height: 22px;
                border: 1px solid ${({theme}) => theme.mainTextColor};
                border-radius: 3px;
                display: flex;
                justify-content: center;
                align-items: center;

                .check-icon{
                    font-size: 1.4rem;
                    fill: ${({theme}) => theme.mainTextColor};
                }
            }

            span{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }

`

const InputSelectMultiple = ({data, setData, labelText, name, inputWidth, options}) => {

    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)

    const idList = data?.map(item => item?.id)

    const handleOptionClick = (item) => {
        if(idList.includes(item?.id)){
            setData(data.filter(innerItem => {
                return innerItem?.id !== item?.id
            }))
        }
        else{
            setData([...data, item])
        }
    }

  return (
    <Container value={data?.length > 0} inputWidth={inputWidth} onClick={e => e.stopPropagation()}>
        <input type="text" id={"text"} onChange={()=> {}} value={data?.map(item => item?.text)} name={"text"} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        options?.map((item) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                <div className="checkbox">
                                    {
                                        idList.includes(item?.id) &&
                                        <MdCheck className="check-icon" />
                                    }
                                </div>
                                <span>{item.text}</span>
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputSelectMultiple